import { allAcceptedFileTypes } from '../constants/accepted-file-types';
import { capitalizeFirstLetter } from '@getaccept/lib-shared/src/helpers';

export class FileHelper {
  static validFileType(fileType: string, acceptedFileTypes = allAcceptedFileTypes): boolean {
    if (!fileType) {
      return false;
    }
    return acceptedFileTypes.includes(fileType.toLowerCase());
  }

  static removeExtension(filename: string): string {
    return filename.substring(0, filename.lastIndexOf('.'));
  }

  static extractFileType(fileName: string): string {
    const lastDotIndex: number = fileName.lastIndexOf('.');
    if (lastDotIndex < 0) {
      return null;
    }
    return fileName.substring(lastDotIndex);
  }

  static getFileType(fileName: string): string {
    const lastDotIndex: number = fileName.lastIndexOf('.');
    if (lastDotIndex < 0) {
      return null;
    }
    return capitalizeFirstLetter(fileName.substring(lastDotIndex + 1));
  }
}
